// adds item to lookup table
export type AddToLookupTableArgs = {
  id: string;
  byId: Record<string, unknown>;
  payload: unknown;
};

export type AddToLookupTableReturn = {
  newById: Record<string, unknown>;
  newAllIDs: string[];
};

export const addToLookupTable = ({
  id,
  byId,
  payload,
}: AddToLookupTableArgs): AddToLookupTableReturn => {
  const newById = { ...byId, [id]: payload };

  return {
    newAllIDs: Object.keys(newById),
    newById,
  };
};
